const numeral = require('numeral');

const cardTypeRegexDict = {
    '^4[0-9]{12}(?:[0-9]{3})?$' : 'visa',
    '^3[47][0-9]{13}$' : 'amex',
    '^6(?:011|5[0-9]{2})[0-9]{12}$' : 'discover',
    '^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$' : 'mastercard',
};

const intOpConfiguration = {
    cardBrand: {
        "0" : "PL",
        "1" : "MasterCard",
        "2" : "Visa",
        "3" : "Maestro",
        "5" : "Isracard",
    },
    clearerId: {
        "1" : "Isracard",
        "2" : "Visa CAL",
        "3" : "Diners",
        "4" : "American Express",
        "6" : "Leumi Card"
    },
    ccCompanyResultForId: {
        "0" : "Not Inserted",
        "1" : "Valid",
        "2" : "Invalid",
        "3" : "Unchecked"
    },
    ccCompanyResultForCVV: {
        "0" : "Not Inserted",
        "1" : "Valid",
        "2" : "Invalid",
        "3" : "Unchecked"
    },
    ccCompanyCode: {
        "1" : "Isracard",
        "2" : "Visa CAL",
        "3" : "Diners",
        "4" : "American Express",
        "5" : "JCB",
        "6" : "Leumi Card"
    },
    dealType: {
        "00" : "Blocked Card",
        "01" : "Regular Compulsory Transaction",
        "02" : "Approved Compulsory Transaction",
        "03" : "Forced Transaction",
        "51" : "Right Transaction",
        "52" : "Cancellation Transaction",
        "53" : "Approved Right Transaction",
    },
    connectionReasonCode: {
        " " : "No Connection Made",
        "1" : "Random Connection",
        "2" : "Connection Made - Cap",
        "3" : "Connection Made - Secret Number",
        "4" : "Connection Made - Magnetic Stripe Service Code",
        "5" : "Connection Made - Terminal Check Request",
        "6" : "Connection Made - Indecisive Blockage",
        "7" : "Connection Made - Zero Cap",
        "8" : "Connection Made - Manually Initiated Request"
    },
    confirmationSource: {
        "1" : "Confirmed by SHVA",
        "2" : "Confirmed by CC Company",
        "3" : "Confirmed by Voice Mail",
        "0" : "Unconfirmed"
    }
};

exports = module.exports = {

    /**
     * Infer the card type from the card number
     * @param cardNum The card number (e.g 1234 5678 9102 3456)
     * @returns {string} One of the following: visa, amex, discover, mastercard
     */
    getCardType: function(cardNum) {
        for(let regex in cardTypeRegexDict) {
            if(!cardNum.match(regex)) {
                continue;
            }
            return cardTypeRegexDict[regex];
        }
        return 'unknown';
    },

    /**
     * Remove leading zeros from a given card number
     * @param cardNum The card number
     * @returns {string} un-padded card number
     */
    removeCardPadding: function(cardNum) {
        return cardNum.replace(/^[0]+/g, '');
    },

    /**
     * Pad a credit card number with leading zeros
     * @param cardNum The card number
     * @return {string} A 19-digit padded credit card
     */
    padCreditCard: function(cardNum) {
        const paddingAmount = 19;

        let padded = '';
        for(let i = paddingAmount; i > cardNum.length; i--) {
            padded += '0';
        }
        padded += cardNum;
        return padded;
    },

    getIntOp: function(intOpString) {
        function intOp(start, end) {
            return intOpString.substring(start - 1, end - 1);
        }

        let status = intOp(1, 4);
        // let displayOrder = intOp(4, 5);
        let cardNum = intOp(5, 24);
        let cardBrand = intOp(24, 25);
        let clearerId = intOp(25, 26);
        // let serviceCode = intOp(26, 29);
        // let paramJ = intOp(29, 30);
        let expDate_MMYY = intOp(30, 34);
        let ccCompanyResultForId = intOp(34, 35);
        let ccCompanyResultForCVV = intOp(35, 36);
        let amountChargedAgorot = intOp(36, 44);
        // let extraData = intOp(44, 52);
        // let amountChargedCochavim = intOp(52, 60);
        let ccCompanyCode = intOp(60, 61);
        let dealType = intOp(61, 63);
        // let creditType = intOp(63, 64);
        // let resultForUcafCavv = intOp(64, 65);
        // let currencyType = intOp(65, 66);
        let transactionCode = intOp(66, 68);
        // let clubCode = intOp(68, 69);
        let connectionReasonCode = intOp(69, 70);
        let confirmationSource = intOp(70, 71);
        let confirmationCode = intOp(71, 78);
        // let firstPaymentAmount = intOp(78, 86);
        // let constPaymentAmount = intOp(86, 94);
        // let numOfPayments = intOp(94, 96);
        // let fileNumber = intOp(96, 98);
        // let registerNumber = intOp(98, 101);
        // let resgiterIdNumber = intOp(101, 104);
        let cardName = intOp(104, 119);
        let isInternationalCard = intOp(119, 120);
        // let userData = intOp(120, 139);

        return {
            status: parseInt(status),
            card: {
                cardName: cardName,
                cardNumber: cardNum.length >= 4 ? cardNum.substring(cardNum.length - 4, cardNum.length) : 'N/A',
                expMonth: expDate_MMYY.substring(0, 2),
                expYear: expDate_MMYY.substring(2, 4),
                international: (isInternationalCard === "1")
            },
            cardBrand: intOpConfiguration.cardBrand[cardBrand.toString()],
            cardClearer: intOpConfiguration.clearerId[clearerId.toString()],
            cardIssuer: intOpConfiguration.ccCompanyCode[ccCompanyCode.toString()],
            idStatus: intOpConfiguration.ccCompanyResultForId[(ccCompanyResultForId || '0').toString()],
            cvvStatus: intOpConfiguration.ccCompanyResultForCVV[(ccCompanyResultForCVV || '0').toString()],
            transaction: {
                amount: numeral(amountChargedAgorot).value(),
                type: intOpConfiguration.dealType[dealType.toString()],
                transactionCode: numeral(transactionCode).value()
            },
            connectionStatus: intOpConfiguration.connectionReasonCode[connectionReasonCode],
            confirmationStatus: intOpConfiguration.confirmationSource[confirmationSource.toString()],
            confirmationCode: numeral(confirmationCode).value()
        };

    }
};
